import React, { useState, useEffect, useContext } from 'react';
import dayjs from 'dayjs';
import styled from 'styled-components';
import { useHistory, useLocation } from 'react-router-dom';
import { AuthContext, ContentContext } from '../../_context';
import CircularProgress from '@material-ui/core/CircularProgress';
import { breakpoints } from '../../_helpers/breakpoints';
import { incentivoTiendas, inventivo_tiendas_2 } from '../../_helpers/commons';
import storage from 'local-storage-fallback';
import { Auth } from 'aws-amplify';
import { ButtonYellow } from '~/_elements';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { HiMiniBellAlert } from "react-icons/hi2";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import ReactTooltip from 'react-tooltip';
import { PiMedalFill } from "react-icons/pi";

import axios from 'axios';

const Wrapper = styled.div`
    //position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    min-height: 100vh;
    /*
    height: 740px;
    background-size: 240px auto;
    background-repeat: no-repeat;
    background-position-y: bottom;
    background-position-x: center;
    background-image: url(/images/top_incentivoautitos.png);
    */

    background-color: #FFC600;
    background-image: url('/images/back_competencia_shellbox.svg'), url('/images/back_competencia_shellbox_d.svg');
    background-repeat: no-repeat, no-repeat;
    background-position: top left, bottom right;
    background-size: 750px auto, 750px auto;

    // setBackground({default: false,
        //                type: 'image',
        //                url: '/images/promo_toystory_background.jpg',
        //                //url: '/images/background_challengebox.jpg',
        //                repeat: 'repeat',
        //                attachment: 'local',
        //                position_x: 'center',
        //                size: 'auto'});



    /* background-repeat: repeat;
    background-image: url(/images/promo_toystory_background.jpg); */

    /* background-image: url(/images/mundial_confeti_izquierda_mb.svg), url(/images/mundial_confeti_derecha_mb.svg); */
    /* background-repeat: no-repeat, no-repeat;
    background-position: left top, right top; */
    
    &.from_outside{
        background-color: #FFC600;
        background-image: url('/images/back_competencia_shellbox.svg'), url('/images/back_competencia_shellbox_d.svg');
        background-repeat: no-repeat, no-repeat;
        background-position: top left, bottom right;
        background-size: 750px auto, 750px auto;
    }
    .bt_custom_hover{
        &.MuiButtonBase-root{
            background-color: #f80606;
            color: #FFFFFF;
            &:hover{
                background-color: #FFFFFF;
                p{
                    color: #f80606!important;
                }
            }
        }
    }
    /*
    setBackground({default: false,
                       type: 'image',
                       url: '/images/back_incentivoautitos4.jpg',
                       //url: '/images/background_challengebox.jpg',
                       repeat: 'repeat',
                       attachment: 'local',
                       size: 'cover'});
    */

    .shake-bell{
        animation: shake 0.5s;
        animation-iteration-count: infinite;
    }   

    @keyframes shake {
        0% { transform: translateX(0) rotate(0deg); }
        20% { transform: translateX(-1px) rotate(-10deg); }
        40% { transform: translateX(1px) rotate(10deg); }
        60% { transform: translateX(-1px) rotate(-8deg); }
        80% { transform: translateX(1px) rotate(8deg); }
        100% { transform: translateX(0) rotate(0deg); }
    }

    .tooltip{
        text-align: center;
        font-size: 15px;
        line-height: 20px;
        font-weight: 500;
        max-width: 400px!important;
        background-color: rgba(248, 6, 6, 1)!important;
        
    }
    .__react_component_tooltip::after {
        background-color: rgba(248, 6, 6, 1)!important;
    }
    .autitos{
        margin-bottom: 0;
        //position: absolute;
    }
    
    .logos{
        display: flex;
        flex-direction: row;
        .select,
        .box,
        .shop{
            //width: 28vw;
            //height: 24vw;
            //padding-bottom: 3vw;
            display: flex;
            align-items: flex-end;
            justify-content: center;
            //background-color: #FFC600;
            border-bottom-left-radius: 5vw;
            border-bottom-right-radius: 5vw;
            //margin-right: 3vw;
        }
        .coca_logo{
            margin-top: 0;
            margin-bottom: 3vw;
            width: 85vw;
        }
        .select{
            .logo{
                width: 20vw;
                padding-bottom: 1.8vw;
                img{
                    float: left;
                    width: 100%;
                }
            }
        }
        .box{
            margin-top: 3vw;
            .logo{
                width: 27vw;
                img{
                    float: left;
                    width: 100%;
                }
            }
        }
        .shop{
            margin-right: 0;
            .logo{
                width: 20vw;
                padding-bottom: 2vw;
                img{
                    float: left;
                    width: 100%;
                }
            }
        }
    }
    .loading{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 30px;
        svg{
            color: #e41e2b;
        }
    }
    .divide_footer{
        width: 100%;
        margin-top: 50px;
        img{
            float: left;
            width: 100%;
        }
    }
    .box_footer_toystory{
        width: 100%;
        /* position: relative; */
        display: flex;
        justify-content: center;
        flex-direction: column;
        /* min-height: 900px; */
        margin-top: 10vw;
        .logo_outer{
            /* position: absolute; */
            display: flex;
            justify-content: center;
            position: relative;
            min-height: 75vw;
            width: 100%;
            background-color: #e41e2b;
            /* top: 50px; */
            .logo{
                width: 80vw;
                position: absolute;
                margin-top: -18vw;
                img{
                    float: left;
                    width: 100%;
                }
            }
        }
        .back{
            /* position: absolute; */
            top: 0;
            width: 100%;
            background-image: url(/images/background_bottom_toystory_mb.svg);
            background-position: top center;
            background-size: cover;
            height: 35vw;
            /* z-index: 5; */
            img{
                float: left;
                width: 100%;
            }
        }
    }
    .box_autitos{
        display: none;
        justify-content: center;
        width: 100%;
        /* margin-bottom: 50px; */
        background-color: #e41e2b;
        .autitos{
            max-width: 500px;
            padding-top: 40px;
            img{
                width: 100%;
                float: left;
            }
        }
    }
    .box_autitos_mb{
        /* width: 90vw; */
        width: 100%;
        display: flex;
        /* margin-top: 40px; */
        justify-content: center;
        .autitos{
            width: 90%;
            img{
                width: 100%;
            }
        }
    }
    >.inner{
        width: 95%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 0;
        .actions{
            width: 100%;
            display: flex;
            flex-direction: column;
            margin-top: 10px;
            .bt_download_reglamento{
                width: 100%;
            }
            .bt_download_instructivo{
                width: 100%;
                margin-left: 0;
                margin-top: 10px;
            }
            .bt_download_transacciones{
                width: 100%;
                margin-left: 0;
                margin-top: 10px;
                line-height: 18px;
                padding-top: 9px!important;
                padding-bottom: 9px!important;
                height: auto;
            }
            .bt_faq,
            .bt_mecanica{
                width: 100%;
                margin-top: 10px;
            }
        }
        >.title{
            display: flex;
            flex-direction: column;
            align-items: center;
            font-family: 'ShellHeavy';
            text-align: center;
            //text-transform: uppercase;
            font-weight: 800;
            width: 100%;
            font-size: 5vw;
            line-height: 6vw;
            margin-bottom: 5.5vw;
            margin-top: 7vw;
            //color: #FFFFFF;
            /* text-shadow: 5px 5px 3px rgba(243,146,0,0.85); */
            .logo_text{
                color: #f80606;
                width: 85vw;
                margin-top: 12px;
                font-size: 12vw;
                line-height: 10vw;
                .red{
                    color: #FFC600;
                }
                img{
                    float: left;
                    width: 100%;
                }
            }

            .tag_title{
                width: 215px;
                img{
                    float: left;
                    width: 100%;
                }
            }
            /* border-bottom: 1px solid #e9e8e8; */
            .line{
                color: #ffffff;
            }
            .brand{
                //white-space: nowrap;
                background: linear-gradient(to right, #FFB300 50%, #FDC517 60%);
                background-clip: text;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                color: transparent;
            }
        }
        .data_station{
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            width: 100%;
            color: #FFFFFF;
            .league{
                display: flex;
                flex-direction: row;
                font-size: 17px;
                line-height: 17px;
                font-weight: 600;
                margin-top: 5px;
            }
            .station{
                display: flex;
                flex-direction: column;
                align-items: center;
                .label{
                    font-size: 12px;
                    line-height: 12px;
                    font-weight: 400;
                    text-transform: uppercase;
                }
                .value{
                    font-size: 40px;
                    line-height: 40px;
                    font-weight: 600;
                    margin-top: 5px;
                }
            }
            .name{
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-top: 30px;
                .label{
                    font-size: 12px;
                    line-height: 12px;
                    font-weight: 400;
                    text-transform: uppercase;
                }
                .value{
                    font-size: 40px;
                    line-height: 40px;
                    font-weight: 600;
                    margin-top: 5px;
                }
            }
            .select_boca{
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-top: 35px;
                width: 100%;
                label{
                    text-transform: uppercase;
                    font-size: 16px;
                    line-height: 16px;
                }
                select{
                    width: 100%;
                    padding: 10px 10px;
                }
            }
        }
        .box_ranking{
            margin-top: 35px;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            .ranking_title{
                font-size: 24px;
                line-height: 24px;
                font-weight: 800;
                text-transform: uppercase;
                color: #FFFFFF;
                margin-bottom: 12px;
                text-shadow: 0 0 3px rgba(243, 146, 0, 0.85);
            }
            .ranking_list{
                width: 100%;
                display: grid;
                grid-template-columns: 1fr;
                gap: 12px;
                max-width: 560px;
            }
            .ranking_card{
                display: flex;
                flex-direction: column;
                background-color: rgba(255, 255, 255, 0.95);
                border-radius: 8px;
                border: 1px solid #e41e2b;
                border-bottom: 5px solid #e41e2b;
                padding: 14px 16px;
                box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19);
                -webkit-box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19);
                -moz-box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19);
                .ranking_header{
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                    .medal{
                        display: flex;
                        font-size: 28px;
                        line-height: 28px;
                        color: #e41e2b;
                        margin-right: 8px;
                    }
                    .position_label{
                        font-size: 13px;
                        line-height: 13px;
                        text-transform: uppercase;
                        font-weight: 700;
                        color: #6a6a6a;
                    }
                    .position_value{
                        margin-left: auto;
                        font-size: 30px;
                        line-height: 30px;
                        font-weight: 900;
                        color: #e41e2b;
                    }
                }
                .ranking_data{
                    display: flex;
                    flex-direction: column;
                    gap: 6px;
                    .item{
                        display: flex;
                        align-items: baseline;
                        .label{
                            /* min-width: 44px; */
                            font-size: 12px;
                            line-height: 14px;
                            font-weight: 700;
                            text-transform: uppercase;
                            color: #6a6a6a;
                            margin-right: 8px;
                        }
                        .value{
                            font-size: 17px;
                            line-height: 19px;
                            font-weight: 700;
                            color: #e41e2b;
                            word-break: break-word;
                        }
                    }
                }
                &.second{
                    border-color: #c91a25;
                    border-bottom-color: #c91a25;
                    .ranking_header{
                        .medal,
                        .position_value{
                            color: #c91a25;
                        }
                    }
                    .ranking_data{
                        .item{
                            .value{
                                color: #c91a25;
                            }
                        }
                    }
                }
            }
        }
        .objective_title{
            font-size: 23px;
            line-height: 23px;
            font-weight: 800;
            text-transform: uppercase;
            margin-top: 40px;
            color: #FFFFFF;//FFC600
            border-bottom: 1px solid #FFFFFF;
            text-align: center;
        }
        .copy{
            max-width: 660px;
            display: flex;
            flex-direction: column;
            text-align: center;
            margin-top: 30px;
            color: #FFFFFF;
                text-shadow: 0 0 3px rgba(243, 146, 0, 0.85);
            p{
                margin: 0;
                padding: 0;
                font-size: 16px;
                line-height: 20px;
            }
            .l1{
                
            }
            .l2,
            .l3{
                font-weight: 600;
                margin-top: 10px;
            }
            .l3{
                color: #FFFFFF;
            }
        }
        
        .box_objective,
        .box_objective_cumplimiento{
            display: flex;
            flex-direction: column;
            margin-top: 10px;
            width: 100%;
            ul, li{
                margin: 0;
                padding: 0;
                list-style: none;
            }
            ul{
                display: flex;
                flex-direction: column;
                li{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    width: 100%;
                    text-align: center;
                    /* background-color: aliceblue; */
                    background-color: rgba(255,255,255,0.95);
                    padding: 20px 30px;
                    margin-right: 0;
                    margin-top: 20px;
                    border-radius: 6px;
                    border: 1px solid #e41e2b;
                    border-bottom: 5px solid #e41e2b;

                    box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19);
                    -webkit-box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19);
                    -moz-box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19);
                    :last-child{
                        margin-right: 0;
                    }
                    .label{
                        text-transform: uppercase;
                        font-size: 12px;
                        line-height: 16px;
                        font-weight: 600;
                        &.label_icon{
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    }
                    .value{
                        font-size: 40px;
                        line-height: 40px;
                        font-weight: 800;
                        margin-top: 7px;
                        color: #e41e2b;
                    }
                }
            }
        }
        .box_objective_cumplimiento{
            align-items: center;
            margin-top: 0;
            width: 100%;
            ul{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                flex-direction: column;
                li{
                    //color: #FFFFFF;
                    width: 100%;
                    border-bottom: 5px solid #FFFFFF;
                    background-color: #e41e2b;
                    .label{
                        color: #FFFFFF;
                    }
                    .value{
                        color: #FFFFFF;
                    }
                    :first-child{
                        margin-right: 0;
                    }
                }
            }
            .publish_date{
                display: flex;
                flex-direction: row;
                align-items: center;
                font-size: 14px;
                line-height: 14px;
                margin-top: 15px;
                font-weight: 600;
                border: 1px dashed #e41e2b;
                padding: 7px 10px 5px 10px;
                border-radius: 6px;
                background-color: #FFFFFF;
                box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19);
                -webkit-box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19);
                -moz-box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19);
                .icon{
                    display: flex;
                    font-size: 21px;
                    line-height: 21px;
                    margin-right: 5px;
                    color: #e41e2b;
                }
                p{
                    padding: 0;
                    margin: 0;
                    color: #e41e2b;
                    line-height: 17px;
                }
            }
        }
    }

    .bt_cursos_pendientes{
        width: 400px;
        margin-top: 30px;
    }
    .bt_guia_para_migrar{
        width: 400px;
        margin-top: 10px;
    }
    .cursos_modal_overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
        padding: 20px;
    }

    .cursos_modal_content {
        position: relative;
        width: 90%;
        max-width: 600px;
        background-color: #FFFFFF;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
        padding: 0;
    }

    .cursos_modal_header {
        position: absolute;
        top: 15px;
        right: 15px;
        z-index: 10000;
    }

    .cursos_modal_body {
        padding: 50px 30px 30px 30px;
        text-align: center;
        
        h3 {
            color: #e41e2b;
            font-size: 24px;
            font-weight: 800;
            margin-bottom: 20px;
            text-transform: uppercase;
        }
        
        >p {
            color: #333;
            font-size: 18px;
            line-height: 24px;
            margin-bottom: 30px;
            text-align: left;
        }
    }

    .cursos_modal_actions {
        display: flex;
        justify-content: center;
        width: 100%;
    }

    .coca_header{
        margin-top: 0;
        margin-bottom: 15px;
        width: 100vw;
        img{
            float: left;
            width: 100%;
        }
    }

    @media ${breakpoints.xs} {
        





        .box_footer_toystory{
            width: 100%;
            /* position: relative; */
            display: flex;
            justify-content: center;
            flex-direction: column;
            /* min-height: 900px; */
            margin-top: 70px;
            .logo_outer{
                /* position: absolute; */
                display: flex;
                justify-content: center;
                position: relative;
                min-height: 450px;
                width: 100%;
                background-color: #e41e2b;
                /* top: 50px; */
                .logo{
                    width: 500px;
                    position: absolute;
                    margin-top: -140px;
                    img{
                        float: left;
                        width: 100%;
                    }
                }
            }
            .back{
                /* position: absolute; */
                top: 0;
                width: 100%;
                background-image: url(/images/background_bottom_toystory.svg);
                background-position: top center;
                background-size: cover;
                height: 206px;
                /* z-index: 5; */
                img{
                    float: left;
                    width: 100%;
                }
            }
        }




        
        .box_autitos_mb{
            width: 400px;
            .autitos{
                width: 100%;
                img{
                    width: 100%;
                }
            }
        }
        .logos{
            display: flex;
            flex-direction: row;
            .coca_logo{
                margin-top: 0;
                margin-bottom: 15px;
                width: 550px;
            }
            .coca_header{
                margin-bottom: 15px;
                max-width: 900px;
                width: 100%;
            }
            .select,
            .box,
            .shop{
                //width: 150px;
                //height: 130px;
                padding-bottom: 15px;
                border-bottom-left-radius: 25px;
                border-bottom-right-radius: 25px;
                //margin-right: 20px;
            }
            .select{
                .logo{
                    width: 100px;
                    padding-bottom: 5px;
                }
            }
            .box{
                margin-top: 15px;
                .logo{
                    width: 125px;
                    img{
                        float: left;
                        width: 100%;
                    }
                }
            }
            .shop{
                margin-right: 0;
                .logo{
                    width: 100px;
                    padding-bottom: 8px;
                }
            }
        }
        >.inner{
            width: 100%;
            .actions{
                width: 400px;
                display: flex;
                flex-direction: column;
                margin-top: 10px;
                .bt_download_reglamento{
                    
                }
                .bt_download_instructivo{
                    margin-left: 0;
                    margin-top: 10px;
                }
                .bt_download_transacciones{
                    width: 100%;
                    margin-left: 0;
                    margin-top: 10px;

                    padding-top: unset!important;
                    padding-bottom: unset!important;
                    height: 40px;
                }
            }
            >.title{
                text-align: center;
                font-weight: 800;
                width: 100%;
                
                margin-bottom: 25px;
                margin-top: 35px;
                //color: #FFFFFF;
                /* border-bottom: 1px solid #e9e8e8; */
                .logo_text{
                    font-size: 70px;
                    line-height: 70px;
                    width: 550px;
                    margin-top: 10px;
                }
                .line{
                    font-size: 25px;
                    line-height: 30px;
                }
                .brand{
                    font-size: 65px;
                    line-height: 65px;
                    white-space: nowrap;
                    //color: #FFFFFF;//FFC600
                }
            }
            .box_objective{
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                margin-top: 30px;
                ul, li{
                    margin: 0;
                    padding: 0;
                    list-style: none;
                }
                ul{
                    display: flex;
                    flex-direction: row;
                    li{
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        /* background-color: aliceblue; */
                        width: 175px;
                        padding: 20px 20px;
                        margin-right: 20px;
                        margin-top: 0;
                        border-radius: 6px;

                        box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19);
                        -webkit-box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19);
                        -moz-box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19);
                        :last-child{
                            margin-right: 0;
                        }
                        .label{
                            text-transform: uppercase;
                            font-size: 12px;
                            line-height: 14px;
                            font-weight: 600;
                        }
                        .value{
                            font-size: 40px;
                            line-height: 40px;
                            font-weight: 800;
                            margin-top: 7px;
                        }
                    }
                }
            }



            .box_objective_cumplimiento{
                ul{
                    flex-direction: row;
                    li{
                        width: 220px;
                        :first-child{
                            margin-right: 15px;
                        }
                        label{
                            line-height: 15px;
                        }
                    }
                }
            }
            .data_station{
                .select_boca{
                    margin-top: 35px;
                    width: 400px;
                    label{
                        text-transform: uppercase;
                        font-size: 16px;
                        line-height: 16px;
                    }
                    select{
                        width: 100%;
                        padding: 10px 10px;
                    }
                }
            }
            .box_ranking{
                .ranking_list{
                    grid-template-columns: repeat(2, minmax(0, 1fr));
                    max-width: 450px;
                }
            }
        }
    }
    @media ${breakpoints.sm} {
        
        /* background-image: url(/images/mundial_confeti_izquierda_tbl.svg), url(/images/mundial_confeti_derecha_tbl.svg); */

        .box_autitos_mb{
            width: 500px;
            .autitos{
                width: 100%;
                img{
                    width: 100%;
                }
            }
        }

        >.inner{
            .box_objective{
                ul{
                    li{
                        width: 235px;
                    }
                }
            }
            .box_objective_cumplimiento{
                ul{
                    li{
                        width: 210px;
                        .label{
                            text-align: center;
                            line-height: 15px;
                        }
                    }
                }
            }
            .box_ranking{
                .ranking_list{
                    max-width: 650px;
                }
            }
        }

        /*
        >.inner{
            width: 90%;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 0;
            background-color: skyblue;
            .actions{
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: center;
                margin-top: 30px;
                .bt_download_reglamento{
                    width: 300px;
                }
                .bt_download_instructivo{
                    width: 300px;
                    margin-left: 10px;
                    margin-top: 0;
                }
                .bt_download_transacciones{
                    width: 380px;
                    margin-left: 10px;
                    margin-top: 0;
                }
            }
        }
        */
    }
    @media ${breakpoints.md} {
        
        /* background-image: url(/images/mundial_confeti_izquierda.svg), url(/images/mundial_confeti_derecha.svg); */
        
        .box_autitos_mb{
            width: 500px;
            display: flex;
            margin-top: 40px;
            justify-content: center;
            .autitos{
                width: 100%;
                img{
                    width: 100%;
                }
            }
        }
        >.inner{
            width: 90%;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 0;
            .actions{
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: center;
                margin-top: 10px;
                .bt_download_reglamento{
                    width: 170px;
                }
                .bt_download_instructivo{
                    width: 150px;
                    margin-left: 10px;
                    margin-top: 0;
                }
                .bt_download_transacciones{
                    width: 180px;
                    margin-left: 10px;
                    margin-top: 0;
                }
                .bt_faq,
                .bt_mecanica{
                    width: 250px;
                    margin-left: 10px;
                    margin-top: 0;
                }
                .bt_mecanica{
                    width: 220px;
                }
            }
        }
    }
    @media ${breakpoints.lg} {
        .box_autitos_mb{
            display: none;
        }
        .box_autitos{
            display: flex;
            justify-content: center;
            width: 100%;
            .autitos{
                width: 100%;
                /* width: 80vw;
                padding-top: 60px; */
                img{
                    width: 100%;
                    float: left;
                }
            }
        }
    }
`

const IncentivoCompetenciaShellBox = props => {
    
    let history = useHistory();
    const requestURL = `${process.env.REACT_APP_FRONT_BASE_URL}/`;

    const { isAuth } = useContext(AuthContext);
    const { userData } = useContext(ContentContext);

    const [ metaData, setMetaData ] = useState(null);
    const [ dataStation, setDataStation ] = useState(null);
    const { search, pathname } = useLocation();
    const [ uid, setUid ] = useState(null);
    const [ token, setToken ] = useState(null);
    const [ modificatedDate, setModificatedDate ] = useState(null);
    const [ ranking, setRanking ] = useState([]);

    const [ actividadObjetivo, setActividadObjetivo ] = useState(null);
    const [ actividadResultado, setActividadResultado ] = useState(null);

    const [ cursosObjetivo, setCursosObjetivo ] = useState(null);
    const [ cursosResultado, setCursosResultado ] = useState(null);
    const [ cursosCalculo, setCursosCalculo ] = useState(null);

    const [ cursosResultadoIndividual, setCursosResultadoIndividual ] = useState(null);
    const [ cursosResultadoEstacion, setCursosResultadoEstacion ] = useState(null);
    const [ showCursosModal, setShowCursosModal ] = useState(false);
    const [ red, setRed ] = useState(null);
    const [ nombreLiga, setNombreLiga ] = useState("");


    useEffect(() => {
            //console.log("🦄pathname", pathname, search, isAuth)
        if(pathname){
            if(pathname == '/competencia-shellbox' || pathname == '/competencia-shellbox/'){
                if(search.length > 0) {
                    
                    const query = new URLSearchParams(search);
                    
                    if(query.get("uid") && query.get("uid").length > 0){
                        setUid(query.get("uid"));
                    }else{

                    }
                }else{

                }
            }
        }
        return () => {}

    }, [pathname, isAuth])

    useEffect(() => {
        //console.log("🦄", isAuth, userData)
        if(isAuth && userData){
            setUid(userData.dni);
        }
        return () => {}

    }, [isAuth, userData])

    //const showDownloadReport = [];
    const showDownloadReport = ["100011", "100012", "100013", "100014", "100015", "37867913","24170408","96377400","31694161","1000777","20045518","200015","40999629","42678472","21433342","39243717","39434390","43055891","40187564","39957946","36904228","37009528","41333353","35902467","32052477","38909266","33873144","36005263","35672267","39521747","43702830","36757295","1000888","38001370","31557695","35920496"];
    //"37867913","24170408","20045518","31694161","33873144","200015","31557695","40999629","42678472","40024715","200032","39243717","96377400","43055891","40187564","39957946","36904228","37120811","41333353","35902467","32052477","38909266","36005263","35672267","39521747","43702830","36757295","35920496","38001370"

    const handleOpenCursosModal = () => {
        setShowCursosModal(true);
    };

    const handleCloseCursosModal = () => {
        setShowCursosModal(false);
    };

    const handleGotoCampusFromModal = () => {
        setShowCursosModal(false);
        handleGotoCampus("/campus");
    };

    const handleGotoCampus = (path) => {
        window.open(path, '_blank');
    }
    // useEffect(() => {

    //     if(pathname){
    //         console.log("pathname", pathname)
    //         if(pathname == '/incentivo-autitos-ferrari'){
    //             if(isAuth !== null){
    //                 if(!isAuth){
    //                     if(search.length > 0) {
                            
    //                         const query = new URLSearchParams(search);
    //                         //console.log("query", query);
    //                         if(query.get("token") && query.get("token").length > 0){
    //                             setToken(query.get("token"));
    //                         }else{

    //                         }
    //                     }else{

    //                     }
    //                 }else{
    //                     getToken();
    //                 }
    //             }else{
    //                 if(search.length > 0) {
                            
    //                     const query = new URLSearchParams(search);
    //                     //console.log("query", query);
    //                     if(query.get("token") && query.get("token").length > 0){
    //                         setToken(query.get("token"));
    //                     }else{

    //                     }
    //                 }
    //             }
    //         }
    //     }
    //     return () => {}

    // }, [pathname, isAuth])

    // useEffect(() => {

    //     if(isAuth && userData){
    //         setUid(userData.dni);
    //     }
    //     return () => {}

    // }, [isAuth, userData])

    // const getData = async () => {
    //     const requestURL = `http://localhost:8888/protagonitas_landings/incentivo_tiendas_2.php`;
    //     //const requestURL = `https://fabianhr.com/protagonistas/incentivo_tiendas_2.php`;

    //     try {
    //         const params = new URLSearchParams()
    //         //params.append('type', "get_data");
    //         params.append('uid', '42220416');

    //         const config = {
    //             headers: {
    //             'Content-Type': 'application/x-www-form-urlencoded'
    //             }
    //         }

    //         const result = await axios.post(requestURL, params, config);
    //         setMetaData(result.data.metas);
    //         setDataStation(result.data.metas[0]);

    //         return result;

    //     } catch (error) {

    //     }
    // }

    /*
    const getData = async (token) => {
        alert("asd")
        //const requestURL = `http://localhost:8888/protagonitas_landings/incentivo_tiendas_2.php`;
        //const requestURL = `https://fabianhr.com/protagonistas/incentivo_tiendas_2.php`;
        const requestURL = 'https://v2-dev.1onesolutions.com/API/meta';

        try {
            //const params = new URLSearchParams()
            //params.append('type', "get_data");
            //params.append('uid', uid);

            const config = {
                headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token//storage.getItem('protagonistas_access_token')
                }
            }
            //config.headers.Authorization = idToken.jwtToken;//temp_token;
            const result = await axios.get(requestURL, config);
            //console.log("result", result.data.single.api)
            setMetaData(result.data.single.meta);
            setDataStation(result.data.single.meta[0]);

            return result;

        } catch (error) {

        }
    }
    */

    const getData = async (token) => {
        //console.log("getData")
        //const requestURL = `http://localhost:8888/protagonitas_landings/incentivo_tiendas_2.php`;
        //const requestURL = `https://fabianhr.com/protagonistas/incentivo_tiendas_2.php`;
        const requestURL = 'https://v2-dev.1onesolutions.com/API/meta';

        try {
            const params = new URLSearchParams()
            params.append('type', "get_data");
            params.append('uid', uid);

            const config = {
                headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'dni': uid,
                //'type': 'toystory',
                'type': 'shellboxapp',
                
                //'Authorization': token//storage.getItem('protagonistas_access_token')
                }
            }
            //config.headers.Authorization = idToken.jwtToken;//temp_token;
            const result = await axios.get(requestURL, config, params);

            //setDataDesempeno(result.data.single);

            //setActividadObjetivo(result.data.single.actividad_individual_objetivo);
            //setActividadResultado(result.data.single.actividad_individual_resultado);
            
            
            
            
            
            //setCursosObjetivo(result.data.single.cursos_individual_objetivo);
            //setCursosResultado(result.data.single.cursos_individual_resultado);




            /*
            setCursosResultado(!result.data.single.cursos_individual_objetivo || isNaN(result.data.single.cursos_individual_resultado) || isNaN(result.data.single.cursos_individual_objetivo) ? 0 : Math.round((result.data.single.cursos_individual_resultado / result.data.single.cursos_individual_objetivo) * 100));//result.data.single.cursos_individual_resultado
            setActividadIndividualCalculo(result.data.single.actividad_individual_resultado >= 1 ? '100' : '0');
            setActividadEstacionCalculo(result.data.single.actividad_estacion_resultado >= 1 ? '100' : '0');
            */


            const metas = result.data.single.meta || [];
            const metasSorted = metas
                .slice()
                .sort((a, b) => {
                    const ai = parseInt(a?.boca, 10);
                    const bi = parseInt(b?.boca, 10);
                    if (isNaN(ai) && isNaN(bi)) return 0;
                    if (isNaN(ai)) return 1;
                    if (isNaN(bi)) return -1;
                    return ai - bi;
                })
                .map(item => ({ ...item, boca: String(parseInt(item?.boca, 10)) }));
                console.log("metasSorted", metasSorted)
            setMetaData(metasSorted);
            setDataStation(metasSorted[0]);
            //setDataStation(result.data.single.meta[0]);
            setModificatedDate(result.data.single.meta[0].modified_date);
            /*
            let tempRanking = [
                {
                    "position": "1",
                    "boca": "1234",
                    "razon_social": "XXXXX",
                    "cumplimiento": 15
                },
                {
                    "position": "2",
                    "boca": "5678",
                    "razon_social": "YYYYY",
                    "cumplimiento": 10
                }
            ];
            */
            const rankingSorted = (result.data.single.ranking /*tempRanking*/ || [])
                .slice()
                .sort((a, b) => {
                    const ac = parseFloat(String(a?.cumplimiento ?? '').replace(',', '.'));
                    const bc = parseFloat(String(b?.cumplimiento ?? '').replace(',', '.'));
                    if (isNaN(ac) && isNaN(bc)) return 0;
                    if (isNaN(ac)) return 1;
                    if (isNaN(bc)) return -1;
                    return bc - ac;
                });

            setRanking(rankingSorted);

            //setNombreLiga('Deheza - (39 Estaciones)');


            if(metasSorted[0].liga === '100013'){
                setNombreLiga('Deheza - (39 Estaciones)');
            }
            if(metasSorted[0].liga === '100014'){
                setNombreLiga('Buenos Aires - (269 Estaciones)');
            }
            if(metasSorted[0].liga === '100011'){
                setNombreLiga('Interior 1 - (191 Estaciones)');
            }
            if(metasSorted[0].liga === '100012'){
                setNombreLiga('Interior 2 - (187 Estaciones)');
            }
            if(metasSorted[0].liga === '100015'){
                setNombreLiga('Interior 3 - (180 Estaciones)');
            }
            //setNombreLiga(metasSorted[0].liga);

            //setCursosResultadoEstacion(!result.data.single.meta[0].nomina || isNaN(result.data.single.meta[0].nomina_completion) || isNaN(result.data.single.meta[0].nomina) ? 0 : (Math.round((result.data.single.meta[0].nomina_completion / result.data.single.meta[0].cursos_estacion_objetivo) * 100)) > 100 ? 100 : Math.round((result.data.single.meta[0].nomina_completion / result.data.single.meta[0].nomina) * 100));
            
            setCursosResultadoEstacion(!metasSorted[0].cursos_estacion_objetivo || isNaN(metasSorted[0].cursos_estacion_resultado) || isNaN(metasSorted[0].cursos_estacion_objetivo) ? 0 : (Math.floor((metasSorted[0].cursos_estacion_resultado / metasSorted[0].cursos_estacion_objetivo) * 100)) > 100 ? 100 : Math.floor((metasSorted[0].cursos_estacion_resultado / metasSorted[0].cursos_estacion_objetivo) * 100));
            setCursosResultadoIndividual(!metasSorted[0].cursos_individual_objetivo || isNaN(metasSorted[0].cursos_individual_resultado) || isNaN(metasSorted[0].cursos_individual_objetivo) ? 0 : Math.round((metasSorted[0].cursos_individual_resultado / metasSorted[0].cursos_individual_objetivo) * 100));
            setRed(metasSorted[0].liga?.toLowerCase());
            /*
            setCursosResultadoEstacion(!result.data.single.meta[0].cursos_estacion_objetivo || isNaN(result.data.single.meta[0].cursos_estacion_resultado) || isNaN(result.data.single.meta[0].cursos_estacion_objetivo) ? 0 : (Math.floor((result.data.single.meta[0].cursos_estacion_resultado / result.data.single.meta[0].cursos_estacion_objetivo) * 100)) > 100 ? 100 : Math.floor((result.data.single.meta[0].cursos_estacion_resultado / result.data.single.meta[0].cursos_estacion_objetivo) * 100));
            setCursosResultadoIndividual(!result.data.single.meta[0].cursos_individual_objetivo || isNaN(result.data.single.meta[0].cursos_individual_resultado) || isNaN(result.data.single.meta[0].cursos_individual_objetivo) ? 0 : Math.round((result.data.single.meta[0].cursos_individual_resultado / result.data.single.meta[0].cursos_individual_objetivo) * 100));
            setRed(result.data.single.meta[0].liga?.toLowerCase());
            */ 
            

            // if(uid && !empresarios.includes(uid)/*result.data.single.meta.length === 1*/){
            //     setActividadObjetivo(result.data.single.meta[0].actividad_individual_objetivo);
            //     setActividadResultado(result.data.single.meta[0].actividad_individual_resultado/*dataDesempeno.actividad_individual_resultado >= dataDesempeno.actividad_individual_objetivo ? '100' : '0'*/);
            //     setCursosObjetivo('100%');
            //     setCursosResultado(!result.data.single.meta[0].cursos_individual_objetivo || isNaN(result.data.single.meta[0].cursos_individual_resultado) || isNaN(result.data.single.meta[0].cursos_individual_objetivo) ? 0 : Math.round((result.data.single.meta[0].cursos_individual_resultado / result.data.single.meta[0].cursos_individual_objetivo) * 100));
            // }else{
            //     setActividadObjetivo(result.data.single.meta[0].actividad_estacion_objetivo/*dataDesempeno.actividad_estacion_objetivo*/);
            //     setActividadResultado(!result.data.single.meta[0].actividad_estacion_objetivo || isNaN(result.data.single.meta[0].actividad_estacion_resultado) || isNaN(result.data.single.meta[0].actividad_estacion_objetivo) ? 0 : Math.round((result.data.single.meta[0].actividad_estacion_resultado / result.data.single.meta[0].actividad_estacion_objetivo) * 100));
            //     setCursosObjetivo('90%');//dataDesempeno.cursos_estacion_objetivo
            //     //console.log("XXXXXX", result?.data?.single?.meta[0].boca)
                
            //     if(result?.data?.single?.meta[0].boca === '548'){
            //         setCursosResultado(90);
            //     }else{
            //         setCursosResultado(!result.data.single.meta[0].nomina || isNaN(result.data.single.meta[0].nomina_completion) || isNaN(result.data.single.meta[0].nomina) ? 0 : (Math.round((result.data.single.meta[0].nomina_completion / result.data.single.meta[0].cursos_estacion_objetivo) * 100)) > 100 ? 100 : Math.round((result.data.single.meta[0].nomina_completion / result.data.single.meta[0].nomina) * 100));
            //         //setCursosResultado(!data.nomina || isNaN(data.nomina_completion) || isNaN(data.nomina) ? 0 : (Math.round((data.nomina_completion / data.cursos_estacion_objetivo) * 100)) > 100 ? 100 : Math.round((data.nomina_completion / data.nomina) * 100));
            //     }
                    
                
            // }
            
            return result;

        } catch (error) {

        }
    }
    
    const handleChangeBoca = (e) => {
        const data = metaData.filter(el => el.boca === e.target.value);
        setDataStation(data[0]);
        //setCursosResultadoEstacion(!data[0].nomina || isNaN(data[0].nomina_completion) || isNaN(data[0].nomina) ? 0 : (Math.round((data[0].nomina_completion / data[0].cursos_estacion_objetivo) * 100)) > 100 ? 100 : Math.round((data[0].nomina_completion / data[0].nomina) * 100));
        setCursosResultadoEstacion(!data[0].cursos_estacion_objetivo || isNaN(data[0].cursos_estacion_resultado) || isNaN(data[0].cursos_estacion_objetivo) ? 0 : (Math.floor((data[0].cursos_estacion_resultado / data[0].cursos_estacion_objetivo) * 100)) > 100 ? 100 : Math.floor((data[0].cursos_estacion_resultado / data[0].cursos_estacion_objetivo) * 100));
        setCursosResultadoIndividual(!data[0].cursos_individual_objetivo || isNaN(data[0].cursos_individual_resultado) || isNaN(data[0].cursos_individual_objetivo) ? 0 : Math.round((data[0].cursos_individual_resultado / data[0].cursos_individual_objetivo) * 100));
    }

    const getToken = async (config) => {

        await Auth.currentSession().then(res=>{
          const idToken = res.getIdToken();
          setToken(idToken.jwtToken);
          //return idToken.jwtToken;
          //config.headers.Authorization = idToken.jwtToken;
        })
      
    }
    /*
    const handleGoto = () => {

        history.push(`/campus/course/3:6733999cd89f8e3151bc883b`);
        //campus/course/3:6733999cd89f8e3151bc883b
    }
    */
   
    const handleDownloadPDF = (pdf) => {
        
        switch (pdf) {
            case "reglamento":
                window.open(requestURL+'pdfs/Reglamento_Competencia_Shell_Box_0909_2026_.pdf', '_blank').focus();
                //window.open('pdfs/Reglamento-Meta_Competencia_Promo_Autitos_Ferrari.pdf', '_blank').focus();
            break;
            // case "instructivo":
            //     window.open(requestURL+'pdfs/Instructivo_Meta_Promo_Autitos_Coleccionables.pdf', '_blank').focus();
            // break;
            case "mecanica":
                window.open(requestURL+'pdfs/COMPETENCIA_SHELL_BOX_MECANICA_SEPT_2026.pdf', '_blank').focus();
            break;
            // case "material_co":
            //     window.open('pdfs/MECANICA_GIFT_CARDS_CO.pdf', '_blank').focus();
            // break;
            // case "material_do":
            //     window.open('pdfs/MECANICA_GIFT_CARDS_DO.pdf', '_blank').focus();
            // break;
            case "guia":
                window.open(requestURL+'pdfs/GUIA_PASOS_MIGRACION_NUEVA_APP_SHELL_BOX.pdf', '_blank').focus();
                //window.open('pdfs/Reglamento-Meta_Competencia_Promo_Autitos_Ferrari.pdf', '_blank').focus();
            break;
          default:
            break;
        }
    
    }

    const handleDownloadExcel = async () => {
        try {
            // Mostrar loading o deshabilitar botón
            
            // Usar los datos que ya tienes de metaData o hacer una nueva petición si necesitas más datos
            let dataForExcel = metaData;
            
            // Si necesitas hacer una petición específica para obtener más datos:
            // const response = await getData(token);
            // dataForExcel = response.data.single.meta;
            
            if (!dataForExcel || dataForExcel.length === 0) {
                alert("No hay datos disponibles para exportar");
                return;
            }
            
            // Preparar los datos para el Excel
            const worksheetData = dataForExcel.map((item, index) => ({
                'N°': index + 1,
                'Boca': item.boca || '---',
                'Razón Social': item.razon_social || '---',
                'Objetivo usuarios migrados': item.description || 0,
                'Resultado': item.description_1 || 0,
                '% Cumplimiento': item.description_2,//item.porcentaje_stock ? item.porcentaje_stock.toFixed(1) + '%' : '0%',
                //'% Cumplimiento Cursos Estación': !item.cursos_estacion_objetivo || isNaN(item.cursos_estacion_resultado) || isNaN(item.cursos_estacion_objetivo) ? 0 : (Math.floor((item.cursos_estacion_resultado / item.cursos_estacion_objetivo) * 100)) > 100 ? 100 : Math.floor((item.cursos_estacion_resultado / item.cursos_estacion_objetivo) * 100),//cursosResultadoEstacion ? cursosResultadoEstacion + '%' : '---',
                // Agregar más campos según lo que necesites
            }));
            
            // Crear el workbook y worksheet
            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.json_to_sheet(worksheetData);
            
            // Configurar el ancho de las columnas
            const columnWidths = [
                { wch: 5 },   // N°
                { wch: 10 },  // Boca
                { wch: 30 },  // Razón Social
                { wch: 18 },  // Stock Recibido
                { wch: 18 },  // Stock Vendido
                { wch: 20 },  // % Cumplimiento
            ];
            worksheet['!cols'] = columnWidths;
            
            // Agregar el worksheet al workbook
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Meta Promo CocaCola');
            
            // Generar el archivo Excel
            const excelBuffer = XLSX.write(workbook, { 
                bookType: 'xlsx', 
                type: 'array' 
            });
            
            // Crear el blob y descargarlo
            const blob = new Blob([excelBuffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            
            // Generar nombre del archivo con fecha actual
            const currentDate = new Date().toISOString().split('T')[0];
            const fileName = `Meta_Promo_ToyStory_${currentDate}.xlsx`;
            
            // Descargar el archivo
            saveAs(blob, fileName);
            
        } catch (error) {
            console.error("Error al generar el archivo Excel:", error);
            alert("Error al generar el archivo Excel. Por favor, intenta nuevamente.");
        }
    };

    const handleGoto = (path) => {
        window.open(path, '_blank');
    }

    
    useEffect(() => {
        //console.log("🍎uid", uid)
        if(uid){
            getData();
        }
    
      return () => {}
    }, [uid])
    

    // useEffect(() => {

    //     if(token){
    //         getData(token);
    //     }
    
    //   return () => {}
    // }, [token])

    useEffect(() => {
        //console.log("🥕")
        /*
        if(userData){
            if(userData.dni){
                
                if(!inventivo_tiendas_2.includes(userData?.dni)){
                    history.push('/');
                }
            }
        }
        */
        return () => {}
      }, [userData])

        const getRankingValue = (value) => {
                if (value === null || value === undefined) return Number.NEGATIVE_INFINITY;
                if (typeof value === 'number') return Number.isFinite(value) ? value : Number.NEGATIVE_INFINITY;
                const parsed = parseFloat(String(value).replace(',', '.').replace(/[^0-9.-]/g, ''));
                return Number.isFinite(parsed) ? parsed : Number.NEGATIVE_INFINITY;
        };

        const topRankingStations = (metaData || [])
                .slice()
                .sort((a, b) => getRankingValue(b?.description_2) - getRankingValue(a?.description_2))
                .slice(0, 2);
    
    //console.log("dataStation", dataStation);

    return (
        <Wrapper 
            className={(isAuth === null || isAuth === false) ? "from_outside" : ""}
        >
            
            {/* <a data-tip data-for='happyFace'> d(`･∀･)b </a> */}
            

            {showCursosModal && (
                <div className='cursos_modal_overlay' onClick={handleCloseCursosModal}>
                    <div className='cursos_modal_content' onClick={(e) => e.stopPropagation()}>
                        <div className='cursos_modal_header'>
                            <button className='close_button' onClick={handleCloseCursosModal}>
                                ✕
                            </button>
                        </div>
                        <div className='cursos_modal_body'>
                            <h3>CURSOS Y CERTIFICACIONES PENDIENTES</h3>
                            <p>
                                Para revisar tu avance, ingresá a <strong>Campus:</strong><br/><br/>
                                - En <strong>“Cursos pendientes”</strong> podrás consultar qué cursos te quedan por realizar y verificar cuáles son obligatorios según tu puesto.<br/><br/>
                                - En <strong>“Certificaciones”</strong> podrás acceder a la Certificación correspondiente a tu puesto y revisar si ya la completaste.<br/><br/>
                                Si sos <strong>Empresario y/o Encargado</strong>, podés consultar esta información desde tu acceso al <strong>Panel</strong>, en la sección <strong>Indicadores</strong>.
                            </p>
                            <div className='cursos_modal_actions'>
                                <ButtonYellow
                                    onClick={handleGotoCampusFromModal}
                                    disabled={false}
                                    css_styles={{background:{normal: '#FFD200', hover: '#000000'}, width: '200px'}}
                                    >
                                    <p>IR A CAMPUS</p>
                                </ButtonYellow>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {(!metaData || !dataStation) ? 

                <div className='loading'>
                    <CircularProgress />
                </div>

                :
                <>
                <div className='inner'>
                    <div className='logos'>
                        {/* <div className='ferrari_header'>
                            <div className='logo'>
                                <img src='images/autitos-starwars3.jpg' />
                            </div>
                        </div> */}
                        <div className='coca_logo'>
                            <div className='logo'>
                                <img src={requestURL+'images/logos_top_competenciashellbox.svg'} />
                            </div>
                        </div>
                        {/* <div className='select'>
                            <div className='logo'>
                                <img src='images/logo_shell_select.svg' />
                            </div>
                        </div> */}
                        {/* <div className='box'>
                            <div className='logo'>
                                <img src='images/logo_shellbox.svg' />
                            </div>
                        </div> */}
                        {/* <div className='shop'>
                            <div className='logo'>
                                <img src='images/Shell-SHOP.jpg' />
                            </div>
                        </div> */}
                    </div>
                    <div className='title'>
                        {/* <div className='line'>PROMO</div> */}
                        <div className='tag_title'>
                            <img src='/images/tag_competencia_shellbox.svg' />
                        </div>
                        <div className='logo_text'>SHELL BOX</div>
                        {/* <div className='brand'>Autitos Ferrari</div> */}
                    </div>
                    <div className='data_station'>
                        <div className='station'>
                            <div className='label'>Boca</div> 
                            <div className='value'>{dataStation?.boca}</div>
                            <ReactTooltip id='happyFace' type='error' className='tooltip'>
                                    <span>Las ligas están divididas en función a las gerencias comerciales.</span>
                                </ReactTooltip>
                            <div className='league' data-tip data-for='happyFace'>
                                

                                <AiOutlineQuestionCircle style={{display: 'flex', marginLeft: '4px', verticalAlign: 'middle', cursor: 'pointer', fontSize: '16px', marginRight: '4px'}} />Área: { nombreLiga }</div>
                        </div>
                        {/* <div className='name'>
                            <div className='label'>
                                Razon Social
                            </div>
                            <div className='value'>{dataStation?.razon}</div>
                        </div> */}
                        {metaData?.length > 1 ?
                        <div className='select_boca'>
                            <label>Seleccionar boca</label>
                            <select id="" onChange={handleChangeBoca}>
                                {metaData.map((boca, index) => {
                                    return(
                                        <option value={boca.boca}>{`${boca.boca} - ${boca?.razon_social}`}</option>
                                    )
                                })}
                            </select>
                        </div>
                        : ""}
                    </div>

                    <div className='box_ranking'>
                        <div className='ranking_title'>Ranking</div>
                        <div className='ranking_list'>
                            {[1, 2].map((position, index) => {
                                const station = topRankingStations[index];
                                return (
                                    <div
                                        key={`ranking-position-${position}`}
                                        className={`ranking_card ${position === 2 ? 'second' : 'first'}`}
                                    >
                                        <div className='ranking_header'>
                                            <span className='medal'><PiMedalFill /></span>
                                            <span className='position_label'>Puesto</span>
                                            <span className='position_value'>{position}</span>
                                        </div>
                                        <div className='ranking_data'>
                                            <div className='item'>
                                                <div className='label'>ES</div>
                                                <div className='value'>{ranking?.[index]?.boca || '---'}</div>
                                            </div>
                                            <div className='item'>
                                                <div className='label'>Razón</div>
                                                <div className='value'>{ranking?.[index]?.razon_social || '---'}</div>
                                            </div>
                                            <div className='item'>
                                                <div className='label'>% Cumplimiento</div>
                                                <div className='value'>{ranking?.[index]?.cumplimiento || '---'}</div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    
                    <div className='objective_title'>
                        Resultados
                    </div>
                    <div className='box_objective'>
                        <ul>
                            <li data-tip data-for='happyFace'>
                                <div className='label label_icon'>
                                    <span>Objetivo usuarios migrados </span>{/*<AiOutlineQuestionCircle style={{display: 'flex', marginLeft: '4px', verticalAlign: 'middle', cursor: 'pointer', fontSize: '16px'}} />*/}
                                </div>
                                {/* <ReactTooltip id='happyFace' type='error' className='tooltip'>
                                    <span>Explicación: Es el % de transacciones participantes de la promo, sobre las transacciones totales que acumulan puntos Shell Box.</span>
                                </ReactTooltip> */}
                                <div className='value'>
                                    {dataStation?.description ? dataStation.description : '---'}
                                </div>
                            </li>
                            <li>
                                <div className='label'>
                                    Resultado de mi estación
                                </div>
                                <div className='value'>
                                    {dataStation?.description_1 ? dataStation.description_1 : '---'}
                                </div>
                            </li>
                            <li>
                                <div className='label'>
                                    % Cumplimiento
                                </div>
                                <div className='value'>
                                    {dataStation?.description_2 ? dataStation.description_2 : '---'}
                                </div>
                            </li>
                        </ul>
                    </div>
                    
                    <div className='box_objective_cumplimiento'>
                        <ul>
                            <li>
                                <div className='label'>
                                    Métrica individual certificado
                                </div>
                                <div className='value'>
                                    {/* {'---'} */}
                                    {cursosResultadoIndividual ? (cursosResultadoIndividual > 100 ? 100 : cursosResultadoIndividual) : '---'}
                                </div>
                            </li>
                            <li>
                                <div className='label'>
                                    % Cumplimiento equipo certificado
                                </div>
                                <div className='value'>
                                    {/* {'---'} */}
                                    {cursosResultadoEstacion ? cursosResultadoEstacion : '---'}
                                    {/* {cursosResultadoEstacion ? (dataStation.boca === '1488' || dataStation.boca === '780') ? 100 : cursosResultadoEstacion : '---'} */}
                                </div>
                            </li>
                        </ul>
                        <div className='publish_date'>
                            <div className='icon shake-bell'><HiMiniBellAlert /></div>
                            {/* <p>Si tenés alguna consulta, escribinos a contacto@somosprotagonistas.com.ar</p> */}
                            {/* <p>Estamos actualizando el estado de las Certificaciones. En las próximas 48 horas vas a poder visualizar la información actualizada.</p> */}
                            <p>Si tenés alguna duda o consulta, envianos tu mail a contacto@somosprotagonistas.com.ar</p>
                        </div>
                    </div>


                    <div className='copy'>
                        {/* <p className='l1'>Las estaciones competirán en distintas ligas según la cantidad de autitos recibidos: Liga A: a partir de 600 autitos / Liga B: de 264 a 576 autitos / Liga C: de 48 a 240 autitos /Liga Estaciones Propias.</p> */}
                        {/* <p className='l2'>Vigencia desde el 13 de abril hasta el 10 de mayo inclusive.</p> */}
                        <p className='l2'>Vigencia desde el 09/09 al 31/10</p>
                        <p className='l2'>Los resultados se actualizarán una vez por semana, los días Martes.</p>
                        {/* <p className='l3'>Información actualizada hasta el {dayjs.utc(modificatedDate).subtract(1, 'day').format('DD/MM/YYYY')} inclusive.</p> */}
                        <p className='l3'>Información actualizada hasta el día 31 de Octubre inclusive.</p>
                    </div>
                    
                    <ButtonYellow
                        className="bt_cursos_pendientes bt_custom_hover"
                        onClick={handleOpenCursosModal}
                        //onClick={() => handleGoto()}
                        //onClick={() => handleGotoCampus("/campus")}
                        disabled={false}
                        css_styles={{background:{normal: '#FFD200', hover: '#000000'}, width: '250px'}}
                        >
                        <p>Certificación / Cursos Pendientes</p>
                    </ButtonYellow>

                    <ButtonYellow
                        className="bt_guia_para_migrar bt_custom_hover"
                        onClick={() => handleDownloadPDF("guia")}
                        //onClick={() => handleGoto()}
                        //onClick={() => handleGotoCampus("/campus")}
                        disabled={false}
                        css_styles={{background:{normal: '#FFD200', hover: '#000000'}, width: '250px'}}
                        >
                        <p>Guía para migrar</p>
                    </ButtonYellow>

                    <div className='actions'>
                    
                        <ButtonYellow
                            className="bt_download_reglamento bt_custom_hover"
                            onClick={() => handleDownloadPDF("reglamento")}
                            disabled={false}
                            css_styles={{background:{normal: '#FFD200', hover: '#000000'}, width: '250px'}}
                            >
                            <p>REGLAMENTO</p>
                        </ButtonYellow>
                        {/*
                            <ButtonYellow
                                className="bt_download_instructivo bt_custom_hover"
                                onClick={() => handleDownloadPDF("mecanica")}
                                disabled={false}
                                css_styles={{background:{normal: '#FFD200', hover: '#000000'}, width: '250px'}}
                                >
                                <p>MECÁNICA</p>
                            </ButtonYellow>
                        */}
                        {/* {red === 'co' ?
                        <ButtonYellow
                            className="bt_mecanica bt_custom_hover"
                            onClick={() => handleDownloadPDF("material_co")}
                            disabled={false}
                            css_styles={{background:{normal: '#FFD200', hover: '#000000'}, width: '250px'}}
                            >
                            <p>MECÁNICA COMPETENCIA</p>
                        </ButtonYellow>
                        :
                        <ButtonYellow
                            className="bt_mecanica bt_custom_hover"
                            onClick={() => handleDownloadPDF("material_do")}
                            disabled={false}
                            css_styles={{background:{normal: '#FFD200', hover: '#000000'}, width: '250px'}}
                            >
                            <p>MECÁNICA COMPETENCIA</p>
                        </ButtonYellow>
                        } */}

                        <ButtonYellow
                            className="bt_mecanica bt_custom_hover"
                            onClick={() => handleDownloadPDF("mecanica")}
                            disabled={false}
                            css_styles={{background:{normal: '#FFD200', hover: '#000000'}, width: '250px'}}
                            >
                            <p>MECÁNICA COMPETENCIA</p>
                        </ButtonYellow>

                        {/* <ButtonYellow
                            className="bt_faq bt_custom_hover"
                            onClick={() => handleGoto("/campus")}
                            disabled={false}
                            css_styles={{background:{normal: '#FFD200', hover: '#000000'}, width: '250px'}}
                            >
                            <p>Material de Capacitación</p>
                        </ButtonYellow> */}
                        
                        {/* <ButtonYellow
                            className="bt_download_transacciones"
                            onClick={() => handleGoto()}
                            disabled={false}
                            css_styles={{background:{normal: '#FFD200', hover: '#000000'}, width: '250px'}}
                            >
                            <p>REPORTE METAS</p>
                        </ButtonYellow> */}
                        
                        {showDownloadReport.includes(uid) &&
                        <ButtonYellow
                            className="bt_download_transacciones bt_custom_hover"
                            onClick={handleDownloadExcel}
                            disabled={!metaData || metaData.length === 0}
                            css_styles={{background:{normal: '#FFD200', hover: '#000000'}, width: '250px'}}
                            >
                            <p>REPORTE METAS</p>
                        </ButtonYellow>}




                        {/* <ButtonYellow
                            className="bt_download_reglamento"
                            onClick={() => handleDownloadPDF("reglamento")}
                            disabled={false}
                            css_styles={{background:{normal: '#FFD200', hover: '#000000'}, width: '250px'}}
                            >
                            <p>REGLAMENTO</p>
                        </ButtonYellow>

                        <ButtonYellow
                            className="bt_download_instructivo"
                            onClick={() => handleDownloadPDF("instructivo")}
                            disabled={false}
                            css_styles={{background:{normal: '#FFD200', hover: '#000000'}, width: '250px'}}
                            >
                            <p>INSTRUCTIVO META</p>
                        </ButtonYellow>

                        <ButtonYellow
                            className="bt_download_transacciones"
                            onClick={() => handleGoto()}
                            disabled={false}
                            css_styles={{background:{normal: '#FFD200', hover: '#000000'}, width: '250px'}}
                            >
                            <p>¿CÓMO IDENTIFICAR TUS TRANSACCIONES?</p>
                        </ButtonYellow>

                        <ButtonYellow
                            className="bt_download_excel"
                            onClick={handleDownloadExcel}
                            disabled={!metaData || metaData.length === 0}
                            css_styles={{background:{normal: '#e41e2b', hover: '#000000'}, width: '250px'}}
                            >
                            <p>DESCARGAR EXCEL</p>
                        </ButtonYellow> */}
                    </div>

                </div>
                </>
            }
        </Wrapper>
    );
};

export default IncentivoCompetenciaShellBox;